/**
 * Single source of truth for the legal consent document version.
 *
 * Stored on every consent record (organizer registration, signup, cookie
 * preferences) so we know which version of Privacy Policy / Terms of Service
 * a user agreed to. Bump this string (date-based, `YYYY-MM-DD`) whenever the
 * content of any of the three legal documents changes materially.
 *
 * There must be exactly ONE definition of this constant in the codebase —
 * every consumer imports it from here rather than redeclaring it.
 */
export const LEGAL_DOCUMENT_VERSION = '2026-10-14';
